



const Button = ({ value }) => {
    return (
        <div className="button-cont">
            <span>
                <input
                    className="button"
                    type="submit"
                    value={value}
                />
            </span>

        </div>
    )
}

export const ButtonGrey = ({ value,loginUrl }) => {
    return (
        <div className="button-grey">
            <span>
                <a className="btn  btn-block buttongrey" href={loginUrl}>{" "} {" "}<i className="fa fa-caret-left">
                </i> {" "}{value}</a>
            </span>
        </div>
    )
}

export default Button